import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { ILogin, Icontext } from 'src/app/shared/interfaces/login.interface';
import { throwError } from 'rxjs/internal/observable/throwError';
import { Observable } from 'rxjs/internal/Observable';
import { IReport, IBingoRooms, IStatus, ICStream, IStreamStatus, roomGametype, IPostStatus, ICreateSession, IUpdateSession, IUpdateStream, ICreateChatroom, ICreateSchedule, IUpdateSchedule, IReqFrontend, IChatRooms, IAssignedRoomApiData, IPreBuyReport, IDeleteSession, IVoidGamesReport, IGameLogsData, IUsersList, ICreateUser, IMenusList, ICreateMenu, ISessionBingoList } from '../../shared/interfaces/gmsdata.interface';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from './authentication.service';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class GmsapidataService {

  //prodUrl = "https://cozy-gms-service.prod.partygaming.local:5001"
  //private baseUrl = "http://stg-cgf-gms.ivycomptech.co.in:443/" //will remove later
  private baseUrl;// = "http://angular-gms.ivycomptech.co.in/api/"; //will remove later
  private _sessionValue: string = null;
  public pjpId = null;
  private apiURls: any;
  constructor(private http: HttpClient, private authSer: AuthenticationService, private cmsSer: CommonService) {
    this.apiURls = environment.urls.api;
    this.baseUrl = this.cmsSer.getApiBaseUrl();//this.cmsSer.getDynaconData("dynacon_gmsCommonSettings", "apiUrl");
    if (this.cmsSer.getIsUsnjServer() != -1) {
      this.baseUrl = this.apiURls.apiUsnjBaseUrl;
    }
  }

  getCheckboxData(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_pjp_checkboxes_list', {}).pipe(
      catchError((err) => this.handleError(err, "jackpotrepots"))
    );
  }

  getTableData(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_pjp_data', data).pipe(
      catchError((err) => this.handleError(err, "jackpotrepots"))
    );
  }

  searchContent(data): Observable<any> {
    return this.http.post(this.baseUrl + 'search', data).pipe(
      catchError((err) => this.handleError(err, "searchWord"))
    );
  }

  getActivePlayers(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_current_active_players', { conditions: {} }).pipe(
      catchError((err) => this.handleError(err, "activePlayers"))
    );
  }

  getChatHostBreakReports(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_chat_host_break_reports', { conditions: data }).pipe(
      catchError((err) => this.handleError(err, "activePlayers"))
    );
  }

  getPlayersActiveLogins(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_players_active_logins', { conditions: data }).pipe(
      catchError((err) => this.handleError(err, "playersActiveLogins"))
    );
  }

  sortOrder(data): Observable<any> {
    return this.http.post(this.baseUrl + 'sort_emoji', { conditions: data }).pipe(
      catchError((err) => this.handleError(err, "sortOrder"))
    );
  }

  getFeatureListCall(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_features_list', data).pipe(
      catchError((err) => this.handleError(err, "featureList"))
    );
  }

  getCategoryListCall(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_category_data', { data: data }).pipe(
      catchError((err) => this.handleError(err, "catList"))
    );
  }

  getFeatureTypeCall(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_features_types', {}).pipe(
      catchError((err) => this.handleError(err, "featureList"))
    );
  }
  featureConfigCall(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_features_config', data).pipe(
      catchError((err) => this.handleError(err, "featureList"))
    );
  }

  featureCloneCall(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_features_clone', data).pipe(
      catchError((err) => this.handleError(err, "Clone featureList"))
    );
  }

  deleteUploadedFilesFromServer(data): Observable<any> {
    return this.http.post(this.baseUrl + 'delete_files', data).pipe(
      catchError((err) => this.handleError(err, "delete_files"))
    );
  }
  getBingoRoomsList(reqRoomInfo: IBingoRooms): Observable<any> {
    return this.http.post(this.baseUrl + 'get_bingo_rooms', reqRoomInfo).pipe(
      catchError((err) => this.handleError(err, "bingoroomslist")));
  }
  changeStatus(statusInfo: IStreamStatus): Observable<any> {
    return this.http.post(this.baseUrl + 'change_stream_status', statusInfo).pipe(
      catchError((err) => this.handleError(err, "roomChangestatus")));
  }

  killRoomData(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'force_kill  ', reqObj).pipe(
      catchError((err) => this.handleError(err, "killRoomData")));
  }

  createStream(reqStreamInfo: ICStream): Observable<any> {
    return this.http.post(this.baseUrl + 'create_stream', reqStreamInfo).pipe(
      catchError((err) => this.handleError(err, "streamInfo")));
  }

  getChatRoomsList(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_chatrooms_list', {}).pipe(
      catchError((err) => this.handleError(err, "chatRoomsList"))
    );
  }
  getChatRoomsData(reqRoomInfo: IChatRooms): Observable<any> {
    return this.http.post(this.baseUrl + 'get_chatrooms', reqRoomInfo).pipe(
      catchError((err) => this.handleError(err, "chatRoomsList"))
    );
  }

  chatRefresh(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_stream_refresh_chatchannel', { conditions: {} }).pipe(
      catchError((err) => this.handleError(err, "chatRoomsList"))
    );
  }
  refreshBadWords(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_stream_refresh_badwords', { conditions: {} }).pipe(
      catchError((err) => this.handleError(err, "chatRoomsList"))
    );
  }

  private handleError(error: HttpErrorResponse, reqFrom) {
    console.log('req Eror from :', reqFrom);
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('Oops!! Something went wrong. Please check the input values and try again.:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        'Backend returned code ${ error.status }, ' +
        'body was: ${ error.error }');
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }
  getChatRoomData(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_chatRoom_dropdown', { conditions: {} }).pipe(
      catchError((err) => this.handleError(err, "ChatRoom in audit logs"))
    );
  }
  getAuditLogData(reqData): Observable<any> {
    return this.http.post(this.baseUrl + 'get_audit_log', { conditions: reqData }).pipe(
      catchError((err) => this.handleError(err, "Error in audit logs"))
    );
  }
  getPrivateChatMessage(reqData): Observable<any> {
    return this.http.post(this.baseUrl + 'get_private_chat_message', { conditions: reqData }).pipe(
      catchError((err) => this.handleError(err, "Error in get private chat message"))
    );
  }

  /* Players screen*/
  getSearchedPlayers(searchData) {
    return this.http.post(this.baseUrl + 'players_search', searchData).pipe(
      catchError((err) => this.handleError(err, "players_search"))
    );
  }

  getPlayerChatDeatils(data) {
    return this.http.post(this.baseUrl + 'update_details', data).pipe(
      catchError((err) => this.handleError(err, "update_details"))
    );
  }

  updatePlayerProperty(data) {
    return this.http.post(this.baseUrl + 'update_property', data).pipe(
      catchError((err) => this.handleError(err, "update_property"))
    );
  }

  /* Games */
  getGamesForBallType(pageOption) {
    return this.http.post(this.baseUrl + 'get_game_list', { 'ball_type': parseInt(pageOption.ballType), 'rows_per_page': pageOption.pageSize, 'page': pageOption.currentPage }).pipe(
      catchError((err) => this.handleError(err, "view_games"))
    );
  }

  getGameDatalist(ballType: string) {
    return this.http.post(this.baseUrl + 'get_game_data_list', { 'ball_type': parseInt(ballType) }).pipe(
      catchError((err) => this.handleError(err, "get_game_data_list"))
    );
  }

  getFeatureSubTypeList(reqObj) {
    return this.http.post(this.baseUrl + 'get_feature_game_list', reqObj).pipe(
      catchError((err) => this.handleError(err, "get_feature_game_list"))
    );
  }

  getPJPData(pjpId) {
    return this.http.post(this.baseUrl + 'get_pjp_game_data', { 'pjp_id': Number(pjpId) }).pipe(
      catchError((err) => this.handleError(err, "get_pjp_game_data"))
    );
  }

  createGame(gameData) {
    return this.http.post(this.baseUrl + 'create_game', gameData).pipe(
      catchError((err) => this.handleError(err, "create_game"))
    );
  }

  getGame(game_id) {
    return this.http.post(this.baseUrl + 'get_game', { "game_id": Number(game_id) }).pipe(
      catchError((err) => this.handleError(err, "get_game"))
    );
  }

  updateGame(data) {
    return this.http.post(this.baseUrl + 'update_game', data).pipe(
      catchError((err) => this.handleError(err, "update_game"))
    );
  }

  /* Patterns */

  getPatternsForBallType(ballType: string) {
    return this.http.post(this.baseUrl + 'get_pattern_list', { 'ball_type': parseInt(ballType) }).pipe(
      catchError((err) => this.handleError(err, "get_pattern_list"))
    );
  }

  createPattern(data) {
    return this.http.post(this.baseUrl + 'create_pattern', data).pipe(
      catchError((err) => this.handleError(err, "create_pattern"))
    );
  }

  updatePattern(data) {
    return this.http.post(this.baseUrl + 'update_pattern', data).pipe(
      catchError((err) => this.handleError(err, "update_pattern"))
    );
  }

  // Manage Sessions  
  getSession(data: IBingoRooms) {
    return this.http.post(this.baseUrl + 'get_sessions', data).pipe(
      catchError((err) => this.handleError(err, "err get_sessions"))
    );
  }
  createSession(data: IUpdateSession) {
    return this.http.post(this.baseUrl + 'create_session', data).pipe(
      catchError((err) => this.handleError(err, "create_session"))
    );
  }
  getSessionData(session_id: number) {
    return this.http.post(this.baseUrl + 'get_session_data', { 'session_id': session_id }).pipe(
      catchError((err) => this.handleError(err, "error get_session_data"))
    );
  }
  getGamesList(bingo_type: number) {
    return this.http.post(this.baseUrl + 'get_games_list', { 'bingo_type': bingo_type }).pipe(
      catchError((err) => this.handleError(err, "error get_games_list"))
    );
  }
  deleteSessionData(data: IDeleteSession) {
    return this.http.post(this.baseUrl + 'delete_session_game', data).pipe(
      catchError((err) => this.handleError(err, "error delete session"))
    );
  }
  getSessionDetails(session_id: number) {
    return this.http.post(this.baseUrl + 'get_session_details', { 'session_id': session_id }).pipe(
      catchError((err) => this.handleError(err, "error get_session_details"))
    );
  }
  updateSession(data) {
    return this.http.post(this.baseUrl + 'update_session', data).pipe(
      catchError((err) => this.handleError(err, "error update_session"))
    );
  }
  addSessionGame(data) {
    return this.http.post(this.baseUrl + 'add_session_game', data).pipe(
      catchError((err) => this.handleError(err, "error add_session_game"))
    );
  }
  updateSessionDetails(data) {
    return this.http.post(this.baseUrl + 'update_session_details', data).pipe(
      catchError((err) => this.handleError(err, "error update_session_details"))
    );
  }
  //Manage Bingo Rooms
  getBingoRooms(data: IBingoRooms) {
    return this.http.post(this.baseUrl + 'get_bingo_rooms', data).pipe(
      catchError((err) => this.handleError(err, "error get_bingo_rooms"))
    );
  }
  getStreamServers() {
    return this.http.post(this.baseUrl + 'get_stream_servers', {}).pipe(
      catchError((err) => this.handleError(err, "error get_stream_servers"))
    );
  }
  changeStreamStatus(data: IPostStatus) {
    return this.http.post(this.baseUrl + 'change_stream_status', data).pipe(
      catchError((err) => this.handleError(err, "err change_stream_status"))
    );
  }
  getChatroomsList() {
    return this.http.post(this.baseUrl + 'get_chatrooms_list', {}).pipe(
      catchError((err) => this.handleError(err, "error get_chatrooms_list"))
    );
  }
  getStreamServerList(reqBingoManager): Observable<any> {
    return this.http.post(this.baseUrl + 'get_servers', reqBingoManager).pipe(
      catchError((err) => this.handleError(err, "getServers"))
    );
  }

  getServers() {
    return this.http.post(this.baseUrl + 'get_servers', {}).pipe(
      catchError((err) => this.handleError(err, "error get_servers"))
    );
  }
  updateStream(reqRoom: roomGametype): Observable<any> {
    return this.http.post(this.baseUrl + 'update_stream', reqRoom).pipe(
      catchError((err) => this.handleError(err, "UpdateStream")));
  }
  // Assign Rooms
  getFrontend(reqfrontend: IReqFrontend): Observable<any> {
    return this.http.post(this.baseUrl + 'get_frontend_id', reqfrontend).pipe(
      catchError((err) => this.handleError(err, "get_frontend_id"))
    );
  }

  getAssignRoomList(reqfrontendID): Observable<any> {
    return this.http.post(this.baseUrl + 'check_frontend_stream', reqfrontendID).pipe(
      catchError((err) => this.handleError(err, "check_frontend_stream"))
    );
  }

  updateFrontedStream(reqUpdateStream): Observable<any> {
    return this.http.post(this.baseUrl + 'update_frontend_stream', { 'input': reqUpdateStream }).pipe(
      catchError((err) => this.handleError(err, "update_frontend_stream"))
    );
  }

  getThemesList(): Observable<any> {
    return this.http.post(this.baseUrl + 'theme_config', {}).pipe(
      catchError((err) => this.handleError(err, "theme_config"))
    );
  }
  // Manage Chat Rooms
  getChatrooms(data: IBingoRooms) {
    return this.http.post(this.baseUrl + 'get_chatrooms', { conditions: data }).pipe(
      catchError((err) => this.handleError(err, "err get_chatrooms"))
    );
  }
  createChatroom(data) {
    return this.http.post(this.baseUrl + 'create_chatroom', data).pipe(
      catchError((err) => this.handleError(err, "err create_chatroom"))
    );
  }
  getChatroomInfo(data) {
    return this.http.post(this.baseUrl + 'get_chatroom_data', data).pipe(
      catchError((err) => this.handleError(err, "err get_chatroom_data"))
    );
  }
  updateChatroom(data) {
    return this.http.post(this.baseUrl + 'update_chatroom', data).pipe(
      catchError((err) => this.handleError(err, "err update_chatroom"))
    );
  }

  // Bingo Room Scheduler
  getStreamsList(reqParameters) {
    return this.http.post(this.baseUrl + 'get_streams_list', reqParameters).pipe(
      catchError((err) => this.handleError(err, "error get_streams_list"))
    );
  }
  getServerTime() {
    return this.http.post(this.baseUrl + 'get_server_time', {}).pipe(
      catchError((err) => this.handleError(err, "error get_server_time"))
    );
  }

  getSchedule(data: IPostStatus) {
    return this.http.post(this.baseUrl + 'get_schedule', data).pipe(
      catchError((err) => this.handleError(err, "err get_schedule"))
    );
  }
  getSessionsList(reqData) {
    return this.http.post(this.baseUrl + 'get_sessions_list', reqData).pipe(
      catchError((err) => this.handleError(err, "error get_sessions_list"))
    );
  }
  createSchedule(data: ICreateSchedule) {
    return this.http.post(this.baseUrl + 'create_schedule', data).pipe(
      catchError((err) => this.handleError(err, "err create_schedule"))
    );
  }
  updateSchedule(data: IUpdateSchedule) {
    return this.http.post(this.baseUrl + 'update_schedule', data).pipe(
      catchError((err) => this.handleError(err, "err update schedule"))
    );
  }
  cloneSchedule(data: any) {
    return this.http.post(this.baseUrl + 'clone_schedule', data).pipe(
      catchError((err) => this.handleError(err, "err cloned schedule"))
    );
  }
  deleteSchedule(schedule_id) {
    return this.http.post(this.baseUrl + 'delete_schedule', { 'schedule_id': schedule_id }).pipe(
      catchError((err) => this.handleError(err, "err delete schedule"))
    );
  }

  // Manage Bingo PJP
  getJackpots() {
    return this.http.post(this.baseUrl + 'get_jackpots', {}).pipe(
      catchError((err) => this.handleError(err, "error get_jackpots"))
    );
  }
  getPrebuyReport(reqObj: IPreBuyReport) {
    return this.http.post(this.baseUrl + 'get_prebuy_reports', reqObj).pipe(
      catchError((err) => this.handleError(err, "err getting prebuy list"))
    );
  }
  getVoidGamesReport(reqObj: IVoidGamesReport) {
    return this.http.post(this.baseUrl + 'void_games_report', reqObj).pipe(
      catchError((err) => this.handleError(err, "err getting void games list"))
    );
  }
  getFrontendList(data) {
    return this.http.post(this.baseUrl + 'get_frontend_list', data).pipe(
      catchError((err) => this.handleError(err, "err getting Frontend list"))
    );
  }
  getDrawNames() {
    return this.http.post(this.baseUrl + 'get_draw_names', {}).pipe(
      catchError((err) => this.handleError(err, "err getting Draw names"))
    );
  }

  getBingoDetailedReport(reportData) {
    return this.http.post(this.baseUrl + 'get_detailed_report', reportData).pipe(
      catchError((err) => this.handleError(err, "get_detailed_report"))
    );
  }

  //Jackpot Management
  getStream(ballType) {
    return this.http.post(this.baseUrl + 'get_streams', { 'ball_type': ballType }).pipe(
      catchError((err) => this.handleError(err, "err get_streams"))
    );
  }
  createPjp(data): Observable<any> {
    return this.http.post(this.baseUrl + 'create_pjp', { data: data }).pipe(
      catchError((err) => this.handleError(err, "err create_pjp"))
    );
  }
  ViewPjp(p_id: any) {
    return this.http.post(this.baseUrl + 'get_pjp', { 'pjp_id': parseInt(p_id) }).pipe(
      catchError((err) => this.handleError(err, "err get_pjp"))
    );
  }
  updatePjp(data): Observable<any> {
    return this.http.post(this.baseUrl + 'update_pjp', data).pipe(
      catchError((err) => this.handleError(err, "err update_pjp"))
    );
  }
  getAllPjpList() {
    return this.http.post(this.baseUrl + 'get_jackpots', {}).pipe(
      catchError((err) => this.handleError(err, "error get_jackpots"))

    );
  }
  getAllAssociatedGamesList(data: any) {
    let url = this.baseUrl + 'get_associated_games';
    return this.http.post(url, data).pipe(
      catchError((err) => this.handleError(err, "error get_associated_games"))

    );
  }
  getPjpDetails(data: any) {
    let url = this.baseUrl + 'get_pjp_details';
    return this.http.post(url, data).pipe(
      catchError((err) => this.handleError(err, "error get_pjp_details"))

    );
  }
  //Data and Reports
  getgameResults(data: IGameLogsData) {
    return this.http.post(this.baseUrl + 'bingo_game_logs', data).pipe(
      catchError((err) => this.handleError(err, "bingo_game_logs"))
    );
  }

  getStreamsDropdown() {
    return this.http.post(this.baseUrl + 'get_streams_dropdown', {}).pipe(
      catchError((err) => this.handleError(err, "error get_streams_list"))
    );
  }

  getViewTicketsdata(data) {
    return this.http.post(this.baseUrl + 'view_tickets', data).pipe(
      catchError((err) => this.handleError(err, "view_tickets"))
    );
  }

  getCardLayoutdata(data) {
    return this.http.post(this.baseUrl + 'show_card', data).pipe(
      catchError((err) => this.handleError(err, "show_card"))
    );
  }

  getGameIdWinnerData(data) {
    return this.http.post(this.baseUrl + 'game_id_winner_data', data).pipe(
      catchError((err) => this.handleError(err, "game_id_winner_data"))
    );
  }

  getGameIdPatternData(data) {
    return this.http.post(this.baseUrl + 'game_id_pattern_data', data).pipe(
      catchError((err) => this.handleError(err, "game_id_pattern_data"))
    );
  }

  getGameIdWinningCardData(data) {
    return this.http.post(this.baseUrl + 'game_id_winning_cards_data', data).pipe(
      catchError((err) => this.handleError(err, "game_id_winning_cards_data"))
    );
  }

  getGameIdFeatureWinData(data) {
    return this.http.post(this.baseUrl + 'game_id_features_win_data', data).pipe(
      catchError((err) => this.handleError(err, "game_id_features_win_data"))
    );
  }

  getLogDetails(data) {
    return this.http.post(this.baseUrl + 'game_id_data', data).pipe(
      catchError((err) => this.handleError(err, "game_id_data"))
    );
  }

  getPlEligibilityList(data) {
    return this.http.post(this.baseUrl + 'get_players_eligibilty_report', { conditions: data }).pipe(
      catchError((err) => this.handleError(err, "err update_pjp"))
    );
  }

  getGameHistoryData(reqData): Observable<any> {
    return this.http.post(this.baseUrl + 'get_game_history', reqData).pipe(
      catchError((err) => this.handleError(err, "Error in get_game_history"))
    );
  }

  getMenusList(reqInfo: IMenusList): Observable<any> {
    return this.http.post(this.baseUrl + 'list_menus', reqInfo).pipe(
      catchError((err) => this.handleError(err, "Error in list_menus"))
    );
  }

  getParentMenuList(flag): Observable<any> {
    return this.http.post(this.baseUrl + 'list_parent_menus', flag).pipe(
      catchError((err) => this.handleError(err, "Error in list_parent_menus"))
    );
  }

  updateMenu(data: ICreateMenu) {
    return this.http.post(this.baseUrl + 'update_menu', { "menu_info": data }).pipe(
      catchError((err) => this.handleError(err, "err update_menu"))
    );
  }
  createMenu(data: ICreateMenu) {
    return this.http.post(this.baseUrl + 'add_menu', { "menu_info": data }).pipe(
      catchError((err) => this.handleError(err, "err add_menu"))
    );
  }

  //Add Smileys

  getEmojiLabels(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_emoji_labels', { conditions: {} }).pipe(
      catchError((err) => this.handleError(err, "emojiList"))
    );
  }

  getEmojiLists(data) {
    return this.http.post(this.baseUrl + 'get_emoji_list', { conditions: data }).pipe(
      catchError((err) => this.handleError(err, "err Emoji Lists"))
    );
  }
  getUsersList(reqInfo: IUsersList): Observable<any> {
    return this.http.post(this.baseUrl + 'list_users', reqInfo).pipe(
      catchError((err) => this.handleError(err, "Users List"))
    );
  }
  getUsersCategoryList(): Observable<any> {
    return this.http.post(this.baseUrl + 'list_categories', {}).pipe(
      catchError((err) => this.handleError(err, "Users category List"))
    );
  }
  deleteDisabledUsers(req): Observable<any> {
    return this.http.post(this.baseUrl + 'delete_gms_user', req).pipe(
      catchError((err) => this.handleError(err, "Deleted users List"))
    );
  }
  getWhitelabelList(): Observable<any> {
    return this.http.post(this.baseUrl + 'list_whitelabels', {}).pipe(
      catchError((err) => this.handleError(err, "Whitelabel List"))
    );
  }
  createUser(data: ICreateUser) {
    return this.http.post(this.baseUrl + 'create_user', { "user_info": data }).pipe(
      catchError((err) => this.handleError(err, "err create user"))
    );
  }
  updateUserData(data) {
    return this.http.post(this.baseUrl + 'update_user', { "user_info": data }).pipe(
      catchError((err) => this.handleError(err, "err User Update"))
    );
  }
  getUserInfo(data) {
    return this.http.post(this.baseUrl + 'get_user_data', data).pipe(
      catchError((err) => this.handleError(err, "err get spesic user data"))
    );
  }
  changeUserPassword(data) {
    return this.http.post(this.baseUrl + 'change_user_password', data).pipe(
      catchError((err) => this.handleError(err, "err in Change User password"))
    );
  }

  //administration - manage roles
  getAllRoles(data) {
    return this.http.post(this.baseUrl + 'list_categories', data).pipe(
      catchError((err) => this.handleError(err, "list_categories"))
    );
  }

  getAllMenus(data) {
    return this.http.post(this.baseUrl + 'list_all_menus', data).pipe(
      catchError((err) => this.handleError(err, "list_all_menus"))
    );
  }

  getMenusForRole(data) {
    return this.http.post(this.baseUrl + 'list_menu_categories', data).pipe(
      catchError((err) => this.handleError(err, "list_menu_categories"))
    );
  }

  updateRole(data) {
    return this.http.post(this.baseUrl + 'update_menu_categories', data).pipe(
      catchError((err) => this.handleError(err, "update_menu_categories"))
    );
  }

  createRole(data) {
    return this.http.post(this.baseUrl + 'add_category', data).pipe(
      catchError((err) => this.handleError(err, "add_category"))
    );
  }

  //Prebuy Refresh
  getprebuyRefresh(data) {
    return this.http.post(this.baseUrl + 'prebuy_refresh_api', data).pipe(
      catchError((err) => this.handleError(err, "prebuy_refresh_api"))
    );
  }
  getRoomsList(): Observable<any> {
    return this.http.post(this.baseUrl + 'prebuy_refresh_room_list', {}).pipe(
      catchError((err) => this.handleError(err, "prebuy_refresh_room_list"))
    );
  }


  getPjpHistory(reqObj: IVoidGamesReport) {
    return this.http.post(this.baseUrl + 'get_bingo_pjp_history', reqObj).pipe(
      catchError((err) => this.handleError(err, "err getting void games list"))
    );
  }

  getCreditMissing(reqObj: IVoidGamesReport) {
    return this.http.post(this.baseUrl + 'credit_missing_report', reqObj).pipe(
      catchError((err) => this.handleError(err, "err getting credit_missing_report"))
    );
  }

  //administration GMS Activity
  getGmsChangeLogsReport(data) {
    return this.http.post(this.baseUrl + 'get_change_logs', data).pipe(
      catchError((err) => this.handleError(err, "get_change_logs "))
    );
  }

  //gms users online
  getUsersOnline(data) {
    return this.http.post(this.baseUrl + 'get_users_online', data).pipe(
      catchError((err) => this.handleError(err, "get_users_online"))
    );
  }
  //game-History Game-ID Info
  getGameIdInfo(data) {
    return this.http.post(this.baseUrl + 'get_game_info', data).pipe(
      catchError((err) => this.handleError(err, "get_game_info "))
    );
  }

  //administration user activity
  getGmsUserActivityReport(data) {
    return this.http.post(this.baseUrl + 'get_activity_logs', data).pipe(
      catchError((err) => this.handleError(err, "get_activity_logs"))
    );
  }


  logoutUser(data) {
    return this.http.post(this.baseUrl + 'logout_user', data).pipe(
      catchError((err) => this.handleError(err, "logout_user"))
    );
  }

  addEmojis(data) {
    return this.http.post(this.baseUrl + 'add_emoji', { "conditions": data }).pipe(
      catchError((err) => this.handleError(err, "err add emojis"))
    );
  }
  deleteEmojis(data) {
    return this.http.post(this.baseUrl + 'delete_emoji', { "conditions": data }).pipe(
      catchError((err) => this.handleError(err, "err delete emojis"))
    );
  }
  multimediaUpload(data) {
    return this.http.post(this.baseUrl + 'multimedia_upload', data).pipe(
      catchError((err) => this.handleError(err, "multimedia_upload"))
    );
  }

  multipleUsersUpload(reqData) {
    return this.http.post(this.baseUrl + 'multiple_users_upload', { "users_info": reqData }).pipe(
      catchError((err) => this.handleError(err, "err while multiple users create"))
    );
  }

  updateChatName(reqData) {
    return this.http.post(this.baseUrl + 'update_chat_name', reqData).pipe(
      catchError((err) => this.handleError(err, "err while updating chat name"))
    );
  }

  getSessionBingoPackages(reqInfo: ISessionBingoList): Observable<any> {
    return this.http.post(this.baseUrl + 'view_packages', reqInfo).pipe(
      catchError((err) => this.handleError(err, "Error in get Session bingo packages list"))
    );
  }

  getsessionPackagesList(reqData) {
    return this.http.post(this.baseUrl + 'list_session_packages', reqData).pipe(
      catchError((err) => this.handleError(err, "err while updating chat name"))
    );
  }

  cancelPackage(reqData) {
    return this.http.post(this.baseUrl + 'cancel_package', reqData).pipe(
      catchError((err) => this.handleError(err, "err while cancel the packages"))
    );
  }

  refreshPackage(reqData) {
    return this.http.post(this.baseUrl + 'refresh_package', reqData).pipe(
      catchError((err) => this.handleError(err, "err while refresh the packages"))
    );
  }

  getSchedules(reqData) {
    return this.http.post(this.baseUrl + 'get_schedules', reqData).pipe(
      catchError((err) => this.handleError(err, "err while get schedules"))
    );
  }
  setCancelPrebuy(reqData) {
    return this.http.post(this.baseUrl + 'cancel_prebuy', reqData).pipe(
      catchError((err) => this.handleError(err, "err while set Cancel Prebuy"))
    );
  }
  createBingoSessionPackage(reqData) {
    return this.http.post(this.baseUrl + 'create_package', { "package_info": reqData }).pipe(
      catchError((err) => this.handleError(err, "err while set Cancel Prebuy"))
    );
  }
  updateBingoSessionPackage(reqData) {
    return this.http.post(this.baseUrl + 'update_package', { "package_info": reqData }).pipe(
      catchError((err) => this.handleError(err, "err while set Cancel Prebuy"))
    );
  }
  getBingoSessionPackage(reqData) {
    return this.http.post(this.baseUrl + 'get_package_info', reqData).pipe(
      catchError((err) => this.handleError(err, "err while set Cancel Prebuy"))
    );
  }

  getsessionBingoReports(reqData) {
    return this.http.post(this.baseUrl + 'session_bingo_reports', reqData).pipe(
      catchError((err) => this.handleError(err, "err while set Cancel Prebuy"))
    );
  }

  //private room configuration
  createPrivateRoom(reqData) {
    return this.http.post(this.baseUrl + 'create_private_room', reqData).pipe(
      catchError((err) => this.handleError(err, "err while creating private room"))
    );
  }

  getPrivateRoomDetails(reqData) {
    return this.http.post(this.baseUrl + 'room_details', reqData).pipe(
      catchError((err) => this.handleError(err, "err while fetching private room details"))
    );
  }

  privateRoomSearch(reqData) {
    return this.http.post(this.baseUrl + 'private_room_search', reqData).pipe(
      catchError((err) => this.handleError(err, "err while creating private room"))
    );
  }
  titleDetails(reqData) {
    return this.http.post(this.baseUrl + 'title_details', reqData).pipe(
      catchError((err) => this.handleError(err, "err while creating private room"))
    );
  }

  playerReportApi(reqData) {
    return this.http.post(this.baseUrl + 'player_report_api', reqData).pipe(
      catchError((err) => this.handleError(err, "err while creating private room"))
    );
  }
  playerEligibilityUpload(reqData) {
    return this.http.post(this.baseUrl + 'player_eligibility_upload', reqData).pipe(
      catchError((err) => this.handleError(err, "err while creating private room"))
    );
  }

  getPrebuyChangeLogs(data) {
    return this.http.post(this.baseUrl + 'get_prebuy_change_logs', data).pipe(
      catchError((err) => this.handleError(err, "get_prebuy_change_logs"))
    );
  }

  createNewFeature(data) {
    return this.http.post(this.baseUrl + 'create_new_feature', data).pipe(
      catchError((err) => this.handleError(err, "create_new_feature"))
    );
  }

  cancelPrivateRoom(data) {
    return this.http.post(this.baseUrl + 'cancel_private_room', data).pipe(
      catchError((err) => this.handleError(err, "create_new_feature"))
    );
  }
  getAutomaticSchedule(data) {
    return this.http.post(this.baseUrl + 'get_automatic_schedule', data).pipe(
      catchError((err) => this.handleError(err, "get_automatic_schedule"))
    );
  }

  getDetailedAutomaticSchedule(data) {
    return this.http.post(this.baseUrl + 'get_detailed_automatic_schedule', data).pipe(
      catchError((err) => this.handleError(err, "get_detailed_automatic_schedule"))
    );
  }

  createAutomaticSchedule(data) {
    return this.http.post(this.baseUrl + 'create_automatic_schedule', data).pipe(
      catchError((err) => this.handleError(err, "create_automatic_schedule"))
    );
  }

  deleteAutomaticSchedule(data) {
    return this.http.post(this.baseUrl + 'delete_automatic_schedule', data).pipe(
      catchError((err) => this.handleError(err, "delete_automatic_schedule"))
    );
  }

  addShortCutKey(data): Observable<any> {
    return this.http.post(this.baseUrl + 'add_shortkey', { conditions: data }).pipe(
      catchError((err) => this.handleError(err, "add_shortkey"))
    );
  }

  getChatLinks(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_chat_link', data).pipe(
      catchError((err) => this.handleError(err, "getChatLinks"))
    );
  }

  addChatLink(data): Observable<any> {
    return this.http.post(this.baseUrl + 'add_chat_link', data).pipe(
      catchError((err) => this.handleError(err, "addChatLinks"))
    );
  }

  deleteChatLink(data): Observable<any> {
    return this.http.post(this.baseUrl + 'delete_chat_link', data).pipe(
      catchError((err) => this.handleError(err, "deleteChatLinks"))
    );
  }

  searchChatLink(data): Observable<any> {
    return this.http.post(this.baseUrl + 'search_chat_link', data).pipe(
      catchError((err) => this.handleError(err, "searchChatLinks"))
    );
  }

  getUsedEmojis(data): Observable<any> {
    return this.http.post(this.baseUrl + 'most_used_emojis', data).pipe(
      catchError((err) => this.handleError(err, "most_used_emojis"))
    );
  }

  getUsedkeywordcount(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_chat_bot_keyword_count', {}).pipe(
      catchError((err) => this.handleError(err, "get_chat_bot_keyword_count"))
    );
  }
  getChatbotKeywordsReport(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_chat_bot_keywords_report', data).pipe(
      catchError((err) => this.handleError(err, "get_chat_bot_keywords_report"))
    );
  }
  getKeywordData(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_chatbot_keyword_list', data).pipe(
      catchError((err) => this.handleError(err, "get_chatbot_keyword_list"))
    );
  }
  getBlockedUsers(): Observable<any> {
    return this.http.post(this.baseUrl + 'blocked_users', {}).pipe(
      catchError((err) => this.handleError(err, "blocked_users"))
    );
  }
  getFriendRequests(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_friend_requests', data).pipe(
      catchError((err) => this.handleError(err, "get_friend_requests"))
    );
  }
  addChatBotKeyword(data): Observable<any> {
    return this.http.post(this.baseUrl + 'add_update_chat_bot_keyword_server', data).pipe(
      catchError((err) => this.handleError(err, "add_update_chat_bot_keyword_server"))
    );
  }

  getDeletedChatbotKeywords(data): Observable<any> {
    return this.http.post(this.baseUrl + 'delete_chat_bot_keyword_server', data).pipe(
      catchError((err) => this.handleError(err, "delete_chat_bot_keyword_server"))
    );
  }

  getBrandInfo() {
    return this.http.post(this.baseUrl + 'get_brand_info', {}).pipe(
      catchError((err) => this.handleError(err, "get_brand_info"))
    );
  }
  getLabels(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_labels', { conditions: {} }).pipe(
      catchError((err) => this.handleError(err, "emojiList"))
    );
  }
  getArchiveChatbot(reqData): Observable<any> {
    return this.http.post(this.baseUrl + 'get_chat_bot_archive_update_list', { "data": reqData }).pipe(
      catchError((err) => this.handleError(err, "get_chat_bot_archive_update_list"))
    );
  }
  getBonusSuppressionReport(reqData): Observable<any> {
    return this.http.post(this.baseUrl + 'get_bonus_suppression', reqData).pipe(
      catchError((err) => this.handleError(err, "get_bonus_suppression"))
    );
  }
  createSuperlink(data): Observable<any> {
    return this.http.post(this.baseUrl + 'create_superlink', data).pipe(
      catchError((err) => this.handleError(err, "create_superlink"))
    );
  }

  assignRoomsSuperlink(data): Observable<any> {
    return this.http.post(this.baseUrl + 'assign_rooms_superlink', data).pipe(
      catchError((err) => this.handleError(err, "assign_rooms_superlink"))
    );
  }

  getSuperlink(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_superlink', data).pipe(
      catchError((err) => this.handleError(err, "get_superlink"))
    );
  }

  searchSuperlink(data): Observable<any> {
    return this.http.post(this.baseUrl + 'search_superlink', data).pipe(
      catchError((err) => this.handleError(err, "search_superlink"))
    );
  }

  getDetailSuperlink(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_detail_superlink', data).pipe(
      catchError((err) => this.handleError(err, "get_detail_superlink"))
    );
  }

  // Assign Rooms Revamp
  getAssignRooms(reqObj) {
    return this.http.post(this.baseUrl + 'get_assign_rooms', reqObj).pipe(
      catchError((err) => this.handleError(err, "get_assign_rooms"))
    );
  }

  updateAssignRooms(reqObj) {
    return this.http.post(this.baseUrl + 'update_assign_rooms', reqObj).pipe(
      catchError((err) => this.handleError(err, "update_assign_rooms"))
    );
  }

  //Game Notifications
  createNotification(data): Observable<any> {
    return this.http.post(this.baseUrl + 'create_notification', data).pipe(
      catchError((err) => this.handleError(err, "create_notification"))
    );
  }

  getLabelSpecificRooms(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_rooms_list', data).pipe(
      catchError((err) => this.handleError(err, "get_rooms_list"))
    );
  }

  getNotificationsList(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_notification', data).pipe(
      catchError((err) => this.handleError(err, "get_notification"))
    );
  }

  viewNotification(data): Observable<any> {
    return this.http.post(this.baseUrl + 'view_notification', data).pipe(
      catchError((err) => this.handleError(err, "view_notification"))
    );
  }

  getPlayersList(data): Observable<any> {
    return this.http.post(this.baseUrl + 'view_notf_players', data).pipe(
      catchError((err) => this.handleError(err, "get_players_list"))
    );
  }

  deleteNotification(data): Observable<any> {
    return this.http.post(this.baseUrl + 'delete_notification', data).pipe(
      catchError((err) => this.handleError(err, "delete_notification"))
    );
  }
  //

  //Chat-Profile
  getAvatars(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_avatar', data).pipe(
      catchError((err) => this.handleError(err, "get_avatar"))
    );
  }

  uploadAvatars(data): Observable<any> {
    return this.http.post(this.baseUrl + 'upload_avatar', data).pipe(
      catchError((err) => this.handleError(err, "upload_avatar"))
    );
  }

  setDefaultAvatar(data): Observable<any> {
    return this.http.post(this.baseUrl + 'set_default_avatar', data).pipe(
      catchError((err) => this.handleError(err, "set_default_avatar"))
    );
  }

  deleteAvatars(data): Observable<any> {
    return this.http.post(this.baseUrl + 'delete_avatars', data).pipe(
      catchError((err) => this.handleError(err, "delete_avatars"))
    );
  }

  getAvatarApprovalReport(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_avatar_approval_report', data).pipe(
      catchError((err) => this.handleError(err, "get_avatar_approval_report"))
    );
  }

  updateAvatarStatus(data): Observable<any> {
    return this.http.post(this.baseUrl + 'update_avatar_approval_report', data).pipe(
      catchError((err) => this.handleError(err, "update_avatar_approval_report"))
    );
  }
  //
  getNotificationEmoji() {
    return this.http.post(this.baseUrl + 'get_notification_emoji', {}).pipe(
      catchError((err) => this.handleError(err, "err add emojis"))
    );
  }
  uploadNotificationEmoji(data) {
    return this.http.post(this.baseUrl + 'upload_notification_emoji', { "conditions": data }).pipe(
      catchError((err) => this.handleError(err, "err add emojis"))
    );
  }

  removeNotificationEmoji(data) {
    return this.http.post(this.baseUrl + 'remove_notification_emoji', { "conditions": data }).pipe(
      catchError((err) => this.handleError(err, "err add emojis"))
    );
  }

  manageGameFeature(data): Observable<any> {
    return this.http.post(this.baseUrl + 'manage_game_feature', data).pipe(
      catchError((err) => this.handleError(err, "manage_game_feature"))
    );
  }

  validateFeatureName(data): Observable<any> {
    return this.http.post(this.baseUrl + 'validate_featurename', data).pipe(
      catchError((err) => this.handleError(err, "validate_featurename"))
    );
  }

  // Wab chat Reports
  getExternalChatFeaturePromoList(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_external_chat_feature_promo_list', data).pipe(
      catchError((err) => this.handleError(err, "get_external_chat_feature_promo_list"))
    );
  }

  getExternalChatFeatureEventList(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_external_chat_feature_event_list ', data).pipe(
      catchError((err) => this.handleError(err, "get_external_chat_feature_event_list "))
    );
  }

  getExternalChatFeatureEventDetails(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_external_chat_feature_event_details ', data).pipe(
      catchError((err) => this.handleError(err, "get_external_chat_feature_event_details "))
    );
  }

  //content-filter, sensitive-data

  addWordData(data): Observable<any> {
    return this.http.post(this.baseUrl + 'add_word_data', data).pipe(
      catchError((err) => this.handleError(err, "add_word_data"))
    );
  }

  getWordList(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_word_list', data).pipe(
      catchError((err) => this.handleError(err, "get_word_list"))
    );
  }

  deleteWord(data): Observable<any> {
    return this.http.post(this.baseUrl + 'delete_word', data).pipe(
      catchError((err) => this.handleError(err, "delete_word"))
    );
  }
  /* Bingo Lobby Management */
  getWhiteLables(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_whitelabels', { "conditions": {} }).pipe(
      catchError((err) => this.handleError(err, "get_whitelables"))
    );
  }

  getLobbyClients(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'get_lobby_clients', reqObj).pipe(
      catchError((err) => this.handleError(err, "get_lobby_clients"))
    );
  }

  getVariants(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'get_variants', reqObj).pipe(
      catchError((err) => this.handleError(err, "get_variants"))
    );
  }
  uploadLobbyImage(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'add_image', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while upload lobby image: add_image"))
    );
  }

  getLobbyImg(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'get_images', reqObj).pipe(
      catchError((err) => this.handleError(err, "get_images"))
    );
  }
  getActiveRoomsImg(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'active_rooms', reqObj).pipe(
      catchError((err) => this.handleError(err, "active_rooms"))
    );
  }
  getLobbyConfiguration(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'get_lobby_configuration', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while Configuring lobby  : get_lobby_configuration"))
    );
  }
  templateCreationLobby(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'create_template', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while Creating template in lobby  : create_template"))
    );
  }

  templateListLobby(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'get_templates', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while retriving template List in lobby  : get_templates"))
    );
  }

  templateCopy(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'copy_template', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while copy template  in lobby : copy_template"))
    );
  }

  deleteImagesLobbyRepo(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'delete_image', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while delete images  in lobby : delete_image"))
    );
  }

  getLobbyPinData(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'get_lobby_pin_data', reqObj).pipe(
      catchError((err) => this.handleError(err, "get_lobby_pin_data"))
    );
  }
  setLobbyPinData(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'set_lobby_pin_data', reqObj).pipe(
      catchError((err) => this.handleError(err, "set_lobby_pin_data"))
    );
  }

  getBannerConfiguration(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'get_banner_configuration', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while get configuration for banner : get_banner_configuration"))
    );
  }

  updateLobbyConfiguration(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'update_lobby_configuration', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while get configuration for banner : update_lobby_configuration"))
    );
  }

  getLobbyLockDisplay(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'get_lobby_lock_display', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while get configuration for banner : get_lobby_lock_display"))
    );
  }
  updateLobbyLockDisplay(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'update_lobby_lock_display', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while get configuration for banner : update_lobby_lock_display"))
    );
  }

  updateBannerConfiguration(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'update_banner_configuration', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while get configuration for banner : update_banner_configuration"))
    );
  }
  deleteBannerConfiguration(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'delete_banner_configuration', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while get configuration for banner : delete_banner_configuration"))
    );
  }
  getStreamChatNames(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'get_stream_chat_names', reqObj).pipe(
      catchError((err) => this.handleError(err, "error while getting data from get_stream_chat_names"))
    );
  }
  updateStreamChatNames(reqObj): Observable<any> {
    return this.http.post(this.baseUrl + 'update_stream_chat_names', reqObj).pipe(
      catchError((err) => this.handleError(err, "error : update_stream_chat_names"))
    );
  }
  /* END Bingo Lobby Management */
  /********* Chat ban report START **********/
  getChatHostsList(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_chat_hosts_list ', data).pipe(
      catchError((err) => this.handleError(err, "get_chat_hosts_list"))
    );
  }
  getChatBanUnbanReport(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_chat_ban_unban_report ', data).pipe(
      catchError((err) => this.handleError(err, "get_chat_ban_unban_report"))
    );
  }
  updateProperty(data): Observable<any> {
    return this.http.post(this.baseUrl + 'update_property ', data).pipe(
      catchError((err) => this.handleError(err, "update_property"))
    );
  }
  /********* Chat ban report END **********/

  getFontsList(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_fonts_list', {}).pipe(
      catchError((err) => this.handleError(err, "fontsList"))
    );
  }
  extendPrivateRoom(data) {
    return this.http.post(this.baseUrl + 'extend_private_room', data).pipe(
      catchError((err) => this.handleError(err, "extend_private_room"))
    );
  }
  getChildPrivateroomData(data) {
    return this.http.post(this.baseUrl + 'eds_room_details', data).pipe(
      catchError((err) => this.handleError(err, "eds_room_details"))
    );
  }
  getPrizeWheelReportData(data) {
    return this.http.post(this.baseUrl + 'get_external_feature_report', data).pipe(
      catchError((err) => this.handleError(err, "get_external_feature_report"))
    );
  }
  /********* DS Safe game Reports START **********/
  getDsEodReports(data) {
    return this.http.post(this.baseUrl + 'get_ds_safe_reports', data).pipe(
      catchError((err) => this.handleError(err, "get_ds_safe_reports"))
    );

  }
  insertDSdata(data) {
    return this.http.post(this.baseUrl + 'set_ds_safe_reports', data).pipe(
      catchError((err) => this.handleError(err, "set_ds_safe_reports"))
    );
  }
  /********* DS Safe game Reports END **********/

  /*******New Lobby Events Start*/

  getCacheEnabledLabels() {
    return this.http.post(this.baseUrl + 'fetch_cache_enabled_labels', {}).pipe(
      catchError((err) => this.handleError(err, "fetch_cache_enabled_labels"))
    );
  }

  getEnableLobbyCache(data) {
    return this.http.post(this.baseUrl + 'enable_lobby_cache', data).pipe(
      catchError((err) => this.handleError(err, "enable_lobby_cache"))
    );
  }

  /*******New Lobby Events End*/

  /******Game client css config Start*******/
  list_css_files(): Observable<any> {
    return this.http.post(this.baseUrl + 'list_css_files', {}).pipe(
      catchError((err) => this.handleError(err, "list_css_files"))
    );
  }

  update_css_file(data): Observable<any> {
    return this.http.post(this.baseUrl + 'update_css_file', data).pipe(
      catchError((err) => this.handleError(err, "update_css_file"))
    );
  }

  /******Game client css config End*******/

  /******************* PLAYER REPORTED ISSUES ************************/

  getReportedIssues(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_reported_issues', data).pipe(
      catchError((err) => this.handleError(err, "get_reported_issues"))
    );
  }

  getNewIssuesLast24h(): Observable<any> {
    return this.http.post(this.baseUrl + 'get_new_issues_last_24h', {}).pipe(
      catchError((err) => this.handleError(err, "get_new_issues_last_24h"))
    );
  }

  updateReportedIssues(data): Observable<any> {
    return this.http.post(this.baseUrl + 'update_reported_issue', data).pipe(
      catchError((err) => this.handleError(err, "update_reported_issues"))
    );
  }

  /******************* END PLAYER REPORTED ISSUES ********************/
  // Rewards Reports
  getRewardsReport(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_rewards_report', data).pipe(
      catchError((err) => this.handleError(err, "get_rewards_report"))
    );
  }

  getRewardsDetailedReport(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_reward_detailed_report', data).pipe(
      catchError((err) => this.handleError(err, "get_reward_detailed_report"))
    );
  }

  getRewardStatusReport(data): Observable<any> {
    return this.http.post(this.baseUrl + 'get_reward_status_report', data).pipe(
      catchError((err) => this.handleError(err, "get_reward_status_report"))
    );
  }
  getRewardSection(data) {
    return this.http.post(this.baseUrl + 'get_rewards_section', data).pipe(
      catchError((err) => this.handleError(err, "get_reward_status_report"))
    );
  }
}
